import type React from 'react';

import type { IconProps } from 'types/icon';

const Menu: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M18.5448 3.5C18.7961 3.5 19 3.70209 19 3.95115C19 4.20021 18.7961 4.40229 18.5448 4.40229H1.45519C1.2039 4.40229 1 4.20021 1 3.95115C1 3.70209 1.2039 3.5 1.45519 3.5H18.5448Z"
        fill={color}
      />
      <path
        d="M18.5448 9.55103C18.7961 9.55103 19 9.75311 19 10.0022C19 10.2512 18.7961 10.4533 18.5448 10.4533H1.45519C1.2039 10.4533 1 10.2512 1 10.0022C1 9.75311 1.2039 9.55103 1.45519 9.55103H18.5448Z"
        fill={color}
      />
      <path
        d="M18.5448 15.5978C18.7961 15.5978 19 15.7999 19 16.0489C19 16.298 18.7961 16.5001 18.5448 16.5001H1.45519C1.2039 16.5001 1 16.298 1 16.0489C1 15.7999 1.2039 15.5978 1.45519 15.5978H18.5448Z"
        fill={color}
      />
    </svg>
  );
};

export default Menu;
